import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./story-page-style.css";
import ConsultFloatButton from "../../custom/consult-float-button/consult-float-button";
import SiteFooter from "../../custom/site-footer/site-footer";
import PageSeo from "../../custom/page-seo/page-seo";
import useIsMobile from "../../../hooks/useIsMobile";

const StoryPageComponent = ({ setShowServiceMenu, setShowPersonalMenu }) => {
  const isMobile = useIsMobile();
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [showNav, setShowNav] = useState(false);
  const [user, setUser] = useState(null);

  //移動裝置抽屜開啟參數
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="story">
      <PageSeo
        title="關於元辰雲閣"
        description="元辰雲閣的創辦理念，把傳統八字命理變得人人都能讀懂，讓命理不再是高深艱澀的學問，而是每個人都能用來認識自己的工具。"
        path="/story"
      />
      {/* 電腦板佈局 */}
      {!isMobile && (
        <div className="story-main">
          {/* 品牌故事-關於元辰雲閣 */}
          <div
            className="first-block"
            onMouseEnter={() => {
              setShowServiceMenu(false);
              setShowPersonalMenu(false);
            }}
          >
            <div className="inner">
              <div className="display-figure">
                <div className="back-card"></div>

                <img
                  src={`/images/bg-figure-5.jpg`}
                  loading="lazy"
                  alt="品牌故事-關於元辰雲閣"
                />
              </div>

              <div className="space"></div>

              <div className="first-des">
                <p className="slogan">品牌故事｜關於元辰雲閣</p>

                <div className="slogan-des">
                  <p className="main-slogan">
                    「命理不是命運的答案，而是未來人生的提案！」
                  </p>

                  <p className="main-des">
                    在浮世喧囂中，我們常常迷路。<br></br>
                    人生有起有伏、有愛有別、有選擇也有等待，而命理，不該只是
                    <br></br>被動接受命運的安排，更可以是看懂這條路的方式。
                  </p>
                </div>

                <Link to="/fortune-service">
                  <button>查看命理服務項目</button>
                </Link>
              </div>
            </div>
          </div>
          {/* 元辰雲閣誕生初衷 */}
          <div
            className="second-block"
            onMouseEnter={() => {
              setShowServiceMenu(false);
              setShowPersonalMenu(false);
            }}
          >
            <div className="content">
              <p className="title">「元辰雲閣」誕生於這樣的初衷—</p>
              <p className="sub-title">
                由深耕命理多年的老師創立，我們希望將古老命術中的智慧，轉譯成每個人都能理解與實踐的生命指南。把古老命理智慧，用更清晰、更易懂、更貼近生活的方式呈現給你。我們用現代的語言解釋命理，用白話說出玄學的底層邏輯，讓每個人都能理解，甚至應用在日常決策中。
              </p>
              <p className="sub-title hight-line">
                我們相信：命理的價值，不在於聽天由命，而在於看懂自己，活出節奏。
              </p>
              <p className="sub-title">
                你不需要背懂五行八卦，不需要看得懂命盤圖，也不需要害怕問太多。在這裡，命理不是艱澀的學問，而是你可以聽懂、看懂、用得上的人生指南。我們提供的不是制式分析或套模建議，而是根據你的命盤，搭配你此刻的狀態與問題，給予真實、有溫度的解釋與提醒。就像一位知心的朋友，也像一位誠實的地圖解說員，陪你讀懂命運裡的線索。
              </p>
              <p className="sub-title">
                「元辰」象徵你的命格能量，「雲閣」則是一座現代化的玄學殿堂。我們希望打造一個不說天書、不賣恐懼的命理空間，讓命理真正成為一門可以靠近、可以理解、可以運用的生活智慧。
              </p>
            </div>
          </div>
          {/*元辰雲閣-讓命理，回歸人的本質*/}
          <div
            className="third-block"
            onMouseEnter={() => {
              setShowServiceMenu(false);
              setShowPersonalMenu(false);
            }}
          >
            <div className="connect">
              <div className="third-des">
                <p className="slogan">
                  元辰雲閣—<br></br>讓命理，回歸人的本質。
                </p>

                <div className="sub-slogan">
                  <div className="v-line"></div>
                  <p>
                    因為命理的真正力量，不是體你做決<br></br>
                    定，而是讓你看懂自己的路，走得更自<br></br>
                    在、更篤定。
                  </p>
                </div>
              </div>

              <div className="figure-img">
                <img
                  src={`/images/bg-figure-2.jpg`}
                  loading="lazy"
                  alt="命理應該被說得更清楚"
                />
              </div>
            </div>
          </div>
          {/*命理專家｜關於帝鎧老師*/}
          <div
            className="forth-block"
            onMouseEnter={() => {
              setShowServiceMenu(false);
              setShowPersonalMenu(false);
            }}
          >
            <div className="concent">
              <div className="display-figure">
                <div className="back-card"></div>

                <img
                  src={`/images/teacher.jpeg`}
                  loading="lazy"
                  alt="用現代思維看懂命運的規律"
                />
              </div>

              <div className="space"></div>

              <div className="forth-des">
                <p className="slogan">命理專家｜關於帝鎧老師</p>

                <p className="small-slogan">
                  命理工程師 帝鎧 - 融合科技與傳統智慧的命理專家
                </p>

                <p className="des">
                  畢業於臺灣科技大學電子研究所碩士班，擁有多年App開發<br></br>
                  經驗，同時深耕東方命理與風水領域，致力於將古老智慧以<br></br>
                  現代科技形式呈現，打造實用又可信賴的命理工具。
                </p>

                {/* <button>大師諮詢</button> */}
              </div>
            </div>
          </div>
          {/*帝鎧老師專精領域*/}
          <div
            className="fifth-block"
            onMouseEnter={() => {
              setShowServiceMenu(false);
              setShowPersonalMenu(false);
            }}
          >
            <p className="slogan">因為專精，所以值得信任</p>

            <p className="sub-slogan">帝鎧老師專精於以下八項領域</p>

            <div className="concent">
              <div className="inner">
                <p>八字命理流年推算</p>
                <p>姓名學諮詢與改名建議</p>
                <p>文王聖卦（六爻占卜）精準預測</p>
                <p>陽宅風水佈局規劃</p>
              </div>

              <div className="inner">
                <p>紫微斗數全盤解讀</p>
                <p>嬰兒擇日剖腹吉時選定</p>
                <p>奇門遁甲開運布局與時空能量應用</p>
                <p>符咒能量開運調理</p>
              </div>
            </div>
          </div>
          {/*隱私政策與聯絡官方*/}
          <SiteFooter />
        </div>
      )}

      {/* 移動裝置佈局*/}
      {isMobile && (
        <div className="story-mobile-main">
          {/* 品牌故事-關於元辰雲閣 */}
          <div
            className="first-block"
            onMouseEnter={() => {
              setShowServiceMenu(false);
              setShowPersonalMenu(false);
            }}
          >
            <div className="display-figure">
              <div className="back-card"></div>
              <img
                src={`/images/bg-figure-5.jpg`}
                loading="lazy"
                alt="品牌故事-關於元辰雲閣"
              />
            </div>

            <p className="slogan">品牌故事｜關於元辰雲閣</p>

            <div className="slogan-des">
              <p className="main-slogan">
                「命理不是命運的答案，而是未來人生的提案！」
              </p>
              <p className="main-des">
                在浮世喧囂中，我們常常迷路。<br></br>
                人生有起有伏、有愛有別、有選擇也有等待，而命理，不該只是被動接受命運的安排，更可以是看懂這條路的方式。
              </p>
            </div>

            <Link to="/fortune-service">
              <button>查看命理服務項目</button>
            </Link>
          </div>

          {/* 元辰雲閣誕生初衷 */}
          <div
            className="second-block"
            onMouseEnter={() => {
              setShowServiceMenu(false);
              setShowPersonalMenu(false);
            }}
          >
            <div className="content">
              <p className="title">
                「元辰雲閣」<br></br>誕生於這樣的初衷—
              </p>
              <p className="sub-title">
                由深耕命理多年的老師創立，我們希望將古老命術中的智慧，轉譯成每個人都能理解與實踐的生命指南。把古老命理智慧，用更清晰、更易懂、更貼近生活的方式呈現給你。我們用現代的語言解釋命理，用白話說出玄學的底層邏輯，讓每個人都能理解，甚至應用在日常決策中。
              </p>
              <p className="sub-title hight-line">
                我們相信：命理的價值，不在於聽天由命，而在於看懂自己，活出節奏。
              </p>
              <p className="sub-title">
                你不需要背懂五行八卦，不需要看得懂命盤圖，也不需要害怕問太多。在這裡，命理不是艱澀的學問，而是你可以聽懂、看懂、用得上的人生指南。我們提供的不是制式分析或套模建議，而是根據你的命盤，搭配你此刻的狀態與問題，給予真實、有溫度的解釋與提醒。就像一位知心的朋友，也像一位誠實的地圖解說員，陪你讀懂命運裡的線索。
              </p>
              <p className="sub-title">
                「元辰」象徵你的命格能量，「雲閣」則是一座現代化的玄學殿堂。我們希望打造一個不說天書、不賣恐懼的命理空間，讓命理真正成為一門可以靠近、可以理解、可以運用的生活智慧。
              </p>
            </div>
          </div>

          {/* 元辰雲閣—讓命理回歸人的本質 */}
          <div
            className="third-block"
            onMouseEnter={() => {
              setShowServiceMenu(false);
              setShowPersonalMenu(false);
            }}
          >
            <div className="figure-img">
              <img
                src={`/images/bg-figure-2.jpg`}
                loading="lazy"
                alt="命理應該被說得更清楚"
              />
            </div>

            <div className="third-des">
              <p className="slogan">
                元辰雲閣—<br></br>讓命理，回歸人的本質。
              </p>
              <div className="sub-slogan">
                <div className="v-line"></div>
                <p>
                  因為命理的真正力量，不是替你做決定，而是讓你看懂自己的路，走得更自在、更篤定。
                </p>
              </div>
            </div>
          </div>

          {/* 命理專家-關於帝鎧老師 */}
          <div
            className="forth-block"
            onMouseEnter={() => {
              setShowServiceMenu(false);
              setShowPersonalMenu(false);
            }}
          >
            <div className="display-figure">
              <div className="back-card"></div>
              <img
                src={`/images/teacher.jpeg`}
                loading="lazy"
                alt="命理專家帝鎧老師"
              />
            </div>

            <div className="forth-des">
              <p className="slogan">命理專家｜關於帝鎧老師</p>
              <p className="small-slogan">
                命理工程師 帝鎧 - 融合科技與傳統智慧的命理專家
              </p>
              <p className="des">
                畢業於臺灣科技大學電子研究所碩士班，擁有多年App開發經驗，同時深耕東方命理與風水領域，致力於將古老智慧以現代科技形式呈現，打造實用又可信賴的命理工具。
              </p>
              <Link to="/personal-chart">
                <button>免費測算命盤</button>
              </Link>
            </div>
          </div>

          {/* 帝鎧老師專精領域 */}
          <div
            className="fifth-block"
            onMouseEnter={() => {
              setShowServiceMenu(false);
              setShowPersonalMenu(false);
            }}
          >
            <p className="slogan">因為專精，所以值得信任</p>
            <p className="sub-slogan">帝鎧老師專精於以下八項領域</p>
            <div className="concent">
              <p>八字命理流年推算</p>
              <p>紫微斗數全盤解讀</p>
              <p>文王聖卦（六爻占卜）精準預測</p>
              <p>陽宅風水佈局規劃</p>
              <p>嬰兒擇日剖腹吉時選定</p>
              <p>符咒能量開運調理</p>
              <p>奇門遁甲開運布局與時空能量應用</p>
              <p>符咒能量開運調理</p>
            </div>
          </div>

          {/*隱私政策與聯絡官方*/}
          <SiteFooter />
        </div>
      )}

      <ConsultFloatButton />
    </div>
  );
};

export default StoryPageComponent;
